import { get } from "lodash";
import { actions } from "./Actions";

const initialState = {
  isLoggedIn: false,
  isValidLogin: false,
  loginError: null,
  selectedSkiSchool: null,
  skiSchools: [],
  retailers: []
};

export function login(state = initialState, action) {
  switch (action.type) {
    case actions.RECEIVE_LOGIN: {
      const statusCode = get(action, "data.code");
      if (statusCode && statusCode === 401) {
        return {
          ...state,
          loginError: true,
        };
      }
      return {
        ...state,
        ...action.data,
        isValidLogin: true,
        loginError: false,
      };
    }
    case actions.SET_LOGOFF: {
      return {
        ...state,
        isLoggedIn: false,
        isValidLogin: false,
        token: null,
        loginError: false,
        selectedSkiSchool: null
      };
    }
    case actions.SET_SELECTED_SKISCHOOL: {
      return {
        ...state,
        selectedSkiSchool: action.skischool,
        isLoggedIn: !!action.skischool,
      }
    }
    case actions.RECEIVE_SKISCHOOLS: {
      return {
        ...state,
        skiSchools: action.data
      }
    }
    case actions.RECEIVE_RETAILERS: {
      return {
        ...state,
        retailers: action.data
      }
    }
    case actions.SET_LOGIN_ERROR: {
      return {
        ...state,
        loginError: action.hasError
      }
    }
    default:
      return state;
  }
}

export default login